import React from 'react';

type CircularProgressProps = {
  size?: string; // Size of the spinner, e.g., 'w-6 h-6'
  color?: string; // Color of the spinner, e.g., 'text-blue-500'
  style: any
  className?: string; // Additional custom classes
};

export const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 'w-6 h-6',
  color = 'text-blue-500',
  style,
  className = '',
}) => {
  return (
    <svg
      style={style}
      className={`animate-spin ${size} ${color} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      />
    </svg>
  );
};